const events = require('../../scripts/events')

module.exports = {
  getCart: async ({ rootState, commit, dispatch }, id) => {
    const config = {
      method: 'get',
      url: `carts/${id}`,
    }
    const response = await dispatch('sendRequest', config, { root: true })
    if (response.status === 'ok') {
      response.data.type = rootState.channel && rootState.channel !== 'default' ? rootState.channel : 'mealtime'
      commit('setCart', response.data, { root: true })
      return null
    } else {
      return response.message
    }
  },
  getCartLocation: async ({ rootState, commit, dispatch }) => {
    if (!rootState.cart) return

    const config = {
      method: 'get',
      url: `locations/${rootState.cart.menu_id}`,
      params: {
        byMenuId: 'true',
      },
    }
    const response = await dispatch('sendRequest', config, { root: true })
    if (response.status === 'ok') {
      commit('setLocation', response.data, { root: true })
      return null
    } else {
      return response.message
    }
  },
  getUser: async ({ commit, dispatch }) => {
    const config = {
      method: 'get',
      url: 'members',
      params: {
        bypass: 'true',
      },
    }
    const response = await dispatch('sendRequest', config, { root: true })
    if (response.status === 'ok') {
      commit('setUser', response.data, { root: true })
      return null
    } else {
      return response.message
    }
  },
  validateCart: async ({ rootState, commit, dispatch, state }) => {
    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'post',
        url: `carts/${rootState.cart.id}/validate`,
      }
      const response = await dispatch('sendRequest', config, { root: true })
      if (response.status === 'ok') {
        commit('setBilling', response.data.billing)
        try {
          await dispatch('getCart', rootState.cart.id)
        } catch (err) {
          console.log(err)
        }
        return null
      } else {
        if (state.billing.length < 1 && rootState.cart) {
          const bConfig = {
            method: 'post',
            url: `carts/${rootState.cart.id}/validate`,
            params: {
              billing: 'true',
            },
          }
          const bResponse = await dispatch('sendRequest', bConfig, { root: true })
          if (bResponse.status === 'ok') {
            commit('setBilling', bResponse.data.billing)
          }
        }
        return response.message
      }
    }
    return null
  },
  getBilling: async ({ rootState, commit, dispatch }) => {
    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'post',
        url: `carts/${rootState.cart.id}/validate?billing=true`,
      }
      const response = await dispatch('sendRequest', config, { root: true })
      if (response.status === 'ok') {
        commit('setBilling', response.data.billing)
        return null
      } else {
        return response.message
      }
    }
    return null
  },
  setPaymentSelection: ({ commit, rootState }, { type, selectedAccountId = null }) => {
    let tracking = rootState.appInfo.library_tracking === false || rootState.appInfo.library_tracking === true ? rootState.appInfo.library_tracking : true
    if (type === 'houseaccount') {
      commit('setPaymentType', type)
      commit('setPaymentId', selectedAccountId)
    } else {
      commit('setPaymentType', type)
      commit('setPaymentAccount', null)
    }

    if (type === 'payinstore' || type === 'houseaccount' || (rootState.location && !rootState.location.payments.split)) {
      commit('setGiftcards', [])
    }

    if (type) {
      const data = {
        payments: [
          {
            type: type,
          },
        ],
      }
      events.pushEvent('add_payment_info', data, window, rootState.location, rootState.cart, rootState.user, tracking, rootState.menu, rootState.channel)
    }
  },
  remainingBalance: ({ state, rootState }) => {
    if (rootState.cart) {
      let total = rootState.cart.totals.total
      state.giftcards.map(g => {
        total -= g.balance
      })
      return total <= 0 ? false : true
    } else {
      return true
    }
  },
  applyGiftcard: ({ commit, state, rootState }, giftcard) => {
    let index = -1
    if (rootState.location && !rootState.location.payments.split) {
      commit('setPaymentSelection', null)
    }
    let giftcards = $nuxt.$store.$utils.copy(state.giftcards)
    giftcards.map((g, i) => {
      // Check stored giftcards
      if (g.id && giftcard.id && g.id === giftcard.id) {
        index = i
        // Check new giftcards
      } else if (g.number && giftcard.number && g.number == giftcard.number) {
        index = i
      }
    })
    // Remove selected giftcards
    if (index > -1) {
      giftcards.splice(index, 1)
      // Add selected giftcards
    } else {
      giftcards.push(giftcard)
    }
    commit('setGiftcards', giftcards)
    if (giftcards.length > 0) {
      if (this.paymentType === 'payinstore' || this.paymentType === 'houseaccount') {
        commit('setPaymentType', null)
      }
    }
    if (!$nuxt.$store.$utils.remainingBalance()) {
      commit('setPaymentType', null)
    }
  },
  removePayment: async ({ dispatch }, card) => {
    const config = {
      method: 'delete',
      url: `members/payments/${card}`,
    }
    await dispatch('sendRequest', config, { root: true })
  },
  gatherPayments: ({ state, rootState }) => {
    // TODO: should we check for rootState.cart first?
    let payments = []
    if (state.type === 'payinstore' || state.type === 'houseaccount') {
      let payment = {
        type: state.type,
      }
      if (state.type === 'houseaccount' && state.paymentId) {
        payment.id = state.paymentId
      }
      payments.push(payment)
    } else {
      const hasTotals = Boolean(rootState.cart.totals)

      let tip = hasTotals ? rootState.cart.totals.tip : 0
      let total = hasTotals ? rootState.cart.totals.total : 0
      let giftcards = state.billing ? state.billing.find(b => b.type === 'giftcard') : []

      if (giftcards) {
        state.giftcards.map(g => {
          if (!g) return
          if (total > 0) {
            const balance = g.balance || 0
            let totalAmount = Math.min(total, balance)
            let totalTip = 0

            if (tip > 0) {
              totalTip = Math.min(tip, balance)
            }

            let giftcard = {
              type: 'giftcard',
              amount: {
                total: totalAmount,
                tip: totalTip,
              },
            }
            if (g.id) {
              giftcard.id = g.id
            } else {
              giftcard.number = g.number || ''
              giftcard.pin = g.pin || ''
            }
            payments.push(giftcard)
            tip = Math.round((tip - totalTip) * 100) / 100
            total = Math.round((total - totalAmount) * 100) / 100
          }
        })
      }
      if (total > 0) {
        let payment = {
          type: 'creditcard',
        }
        if (state.account && state.account.id) {
          payment.id = state.account.id
        } else {
          payment.type = 'remaining'
        }
        // if(payments.length > 0) {
        payment.amount = {
          total,
          tip,
        }
        // }
        payments.push(payment)
      }
    }
    return payments
  },
  submitCart: async ({ rootState, state, dispatch, commit }, payments) => {
    if (rootState.cart && rootState.cart.id) {
      let configClone = null
      const config = {
        method: 'post',
        url: `carts/${rootState.cart.id}/submit`,
        headers: {
          verify: true
        },
        data: {
          payments,
        },
      }
      if (!rootState.token) {
        if (rootState.user) {
          config.data.first_name = rootState.user.first_name
          config.data.last_name = rootState.user.last_name
          config.data.email = rootState.user.email
          config.data.phone = rootState.user.phone

          if (rootState.user.create) {
            config.data.create = true
          }
        } else if (state.guestUser) {
          config.data.first_name = state.guestUser.first_name
          config.data.last_name = state.guestUser.last_name
          config.data.phone = state.guestUser.phone
          config.data.email = state.guestUser.email

          if (state.guestUser.create) {
            config.data.create = true
          }
        } else {
          const message = 'Please enter your name, email, and phone number to checkout'
          commit('setErrors', message, { root: true })
          return
        }
      } else {
        if (rootState.user) {
          config.data.first_name = rootState.user.first_name
          config.data.last_name = rootState.user.last_name
          config.data.email = rootState.user.email
          config.data.phone = rootState.user.phone
        }
      }
      if(rootState.order.handoffMode == 'dinein') {

      }

      if (window.testCartError) {
        configClone = JSON.parse(JSON.stringify(config))
        config.data.payments = { }
      }

      if (process.env.TEST_CHECKOUT) {
        this.$utils.log(config)
      } else {
        const submitCartKey = `submitCart-${rootState.cart.id}`
        if(rootState.failed[submitCartKey]) {
          const cartResponse =  await dispatch('sendRequest', {
            method: 'get',
            url: `carts/${rootState.cart.id}`
          }, { root: true })
          if (cartResponse.data.order_id) {
            commit('setFailed', {
              ...state.failed,
              [submitCartKey]: false
            })
            dispatch('handleSuccess', cartResponse.data.order_id)
            return null
          }
        }
        const response = await dispatch('sendRequest', config, { root: true })
        if (response.status === 'ok') {
          const data = response.data
          let tracking = rootState.appInfo.library_tracking === false || rootState.appInfo.library_tracking === true ? rootState.appInfo.library_tracking : true
          events.pushEvent('purchase', data, window, rootState.location, rootState.cart, rootState.user, tracking, rootState.menu, rootState.channel)
          if (rootState.groupOrder && rootState.groupOrder.paymenttype === 'split' && rootState.groupOrder.name === rootState.groupOrder.hostfullname) {
            await dispatch('order/submitGroupOrder', rootState.groupOrder.id, { root: true })
          }
          dispatch('handleSuccess', data.id)
          return null
        } else {
          commit('setFailed', {
            ...state.failed,
            [submitCartKey]: true,
          }, { root: true })
          if(window.testCartError) {
            setTimeout(async () => {
              const response = await dispatch('sendRequest', configClone, { root: true })
            }, 10000)
          }
          return response.message
        }
      }
    }
    return null
  },
  handleSuccess: ({ state, rootState, commit, dispatch }, id) => {
    commit('setLoading', false, { root: true })
    commit('setApplyDefaultTip', true)

    if (state.placement === 'app') {
      try {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(id)
          // commit('setErrors', { title: 'Success!', message: `Order <small><code>${id}</code></small> successfully placed. You may close the webview. -- ReactNativeWebView --` }, { root: true })
        } else if (window.webView) {
          window.webView.postMessage(id)
          // commit('setErrors', { title: 'Success!', message: `Order <small><code>${id}</code></small> successfully placed. You may close the webview. -- webView --` }, { root: true })
        } else {
          window.parent.postMessage(id)
          // commit('setErrors', { title: 'Success!', message: `Order <small><code>${id}</code></small> successfully placed. You may close the webview. -- parent --` }, { root: true })
        }
        commit('setToken', null, { root: true })
        commit('setAppState', null, { root: true })
        commit('setUser', null, { root: true })
        // for logging
        // commit('setErrors', { title: 'Success!', message: `Order <small><code>${id}</code></small> successfully placed. You may close the webview.` }, { root: true })
      } catch (error) {
        commit('setErrors', error, { root: true }) 
      }
    } else {
      if (state.guestUser) {
        commit('setUser', null, { root: true })
      }
      if (rootState.user) {
        dispatch('members/getRewards', null, { root: true })
      }
      if (rootState.groupOrder && rootState.groupOrder.name !== rootState.groupOrder.hostfullname) {
        commit(
          'setSitePopupInfo',
          {
            icon: 'icon-success primary',
            heading: 'Your order has been submitted',
            body: `Payment is not tendered until host completes the group order.`,
            dismiss: {
              class: 'btn primary',
              title: 'Close',
            },
          },
          { root: true }
        )
        commit('setShowSitePopup', true, { root: true })
        $nuxt.$router.push('/')
        setTimeout(() => {
          commit('setCart', null, { root: true })
          commit('setGroupOrder', null, { root: true })
          commit('setGiftcards', [])
          console.log('Cart Cleaned')
        }, 2000)
      } else {
        $nuxt.$router.push(`/order/confirm/${id}`)
        //Debugging a cart clear issue
        setTimeout(() => {
          commit('setCart', null, { root: true })
          commit('setGroupOrder', null, { root: true })
          commit('setGiftcards', [])
          console.log('Cart Cleaned')
        }, 2000)
      }
    }
  },
  getCartRewards: async ({ rootState, commit, dispatch }) => {
    if (rootState && rootState.appInfo && rootState.appInfo.checkout && rootState.appInfo.checkout.rewards === false) return

    commit('setLoading', true, { root: true })

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'get',
        url: `carts/${rootState.cart.id}/rewards`,
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        commit('setRewards', response.data)
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          // suppress this message
          if (response.message === 'Rewards are not enabled.') {
            commit('setLoading', false, { root: true })
            return
          }

          // Force remove shopping basket error
          if (response.message === 'Could not load shopping basket') {
            commit('setLoading', false, { root: true })
            return
          }

          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
      }
    }
    commit('setLoading', false, { root: true })
  },
  applyCartReward: async ({ rootState, commit, dispatch }, reward) => {
    commit('setLoading', true, { root: true })

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'put',
        url: `carts/${rootState.cart.id}/rewards`,
        data: { id: reward.id },
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        commit('setLoading', false, { root: true })
        return true
      } else {
        commit('setLoading', false, { root: true })
        commit('setErrors', response.message, { root: true })
        return false
      }
    }
    commit('setLoading', false, { root: true })
    return false
  },
  removeCartReward: async ({ rootState, commit, dispatch }, reward) => {
    commit('setLoading', true, { root: true })

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'delete',
        url: `carts/${rootState.cart.id}/rewards`,
        data: {
          id: reward.id,
        },
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        await dispatch('getCartRewards')
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
      }
    }
    commit('setLoading', false, { root: true })
  },
  getCartUpsells: async ({ rootState, commit, dispatch }, params = {}) => {
    if (rootState.appInfo && rootState.appInfo.disabled_features && rootState.appInfo.disabled_features.get_cart_upsells) {
      return false
    }
    const $utils = $nuxt.$store.$utils
    commit('setLoading', true, { root: true })

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'get',
        url: `carts/${rootState.cart.id}/products`,
        params,
      }

      const response = await dispatch('sendRequest', config, { root: true })
      if (response.status === 'ok') {
        const rawUpsells = response.data.products && response.data.products.length > 0 ? response.data.products : []

        // remove items that are in the cart
        filteredUpsells = rawUpsells.map(upsell => {
          if (rootState.cart && rootState.cart.products) {
            const prodFound = rootState.cart.products.find(prod => upsell.product_id === prod.product_id)
            if (!prodFound) {
              return upsell
            }
          } else {
            return upsell
          }
        })

        const shuffledUpsells = $utils.shuffleArray(rawUpsells)

        commit('setUpsells', shuffledUpsells)
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
      }
    }
    commit('setLoading', false, { root: true })
  },
  removeUpsell: async ({ state, commit }, payload) => {
    if (state.upsells && Array.isArray(state.upsells)) {
      const upsells = $nuxt.$store.$utils.copy(state.upsells)
      const upsellIdxFound = upsells.findIndex(upsell => upsell.product_id === payload.id)
      if (upsellIdxFound >= 0) {
        upsells.splice(upsellIdxFound, 1)
        commit('setUpsells', upsells)
      }
    }
  },
  applyCartCoupon: async ({ rootState, commit, dispatch }, coupon) => {
    commit('setLoading', true, { root: true })

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'put',
        url: `carts/${rootState.cart.id}/coupons`,
        data: {
          code: coupon,
        },
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        return true
      } else {
        if (response && response.message.includes('This coupon is not valid for this order')) {
          commit('setErrors', 'This coupon is not valid for this order. Please double check your code, then make sure you’ve added the correct menu item to cart in order to redeem.', { root: true })
        } else {
          commit('setErrors', response.message, { root: true })
        }
      }
    }

    commit('setLoading', false, { root: true })
    return false
  },
  removeCartCoupon: async ({ rootState, commit, dispatch }) => {
    commit('setLoading', true, { root: true })

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'delete',
        url: `carts/${rootState.cart.id}/coupons`,
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
      }
    }
    commit('setLoading', false, { root: true })
  },
  applyCartTip: async ({ rootState, commit, dispatch }, tip) => {
    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'put',
        url: `carts/${rootState.cart.id}/tip`,
        data: {
          amount: tip,
        },
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        // getCart
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
      }
    }
  },
  applyCartOnPremiseDetails: async ({ rootState, commit, dispatch }, payload) => { 
    if (!rootState.cart) {
      await dispatch('createCart', false, { root: true })
    }

    if (rootState.cart && rootState.cart.id) { 
      const config = {
        method: 'put',
        url: `carts/${rootState.cart.id}/handoff/onpremisedetails`,
        data: { ...payload },
      }
      try { 
        const response = await dispatch('sendRequest', config, { root: true })
      } catch (error) {
        console.error('Error communicating with the API:', error)
        commit('setErrors', ['Error communicating with the API'], { root: true })
        commit('setLoading', false, { root: true }) // Ensure loading is set to false on API error
        return null // Return null in case of API call failure
      }
    } else {
      commit('setLoading', false, { root: true })
      return null
    }
  },
  applyCartHandoff: async ({ rootState, commit, dispatch }, payload) => {
    commit('setLoading', true, { root: true })
    const { handoffMode } = payload
    delete payload.handoffMode // remove the handoff from the payload

    if (!rootState.cart) {
      await dispatch('createCart', false, { root: true })
    }

    // if(handoffMode == 'dinein') {
    //   payload.deliverymode = handoffMode
    //   payload.handoffMode = handoffMode
    // }

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'put',
        url: `carts/${rootState.cart.id}/handoff/${handoffMode}`,
        data: ['delivery', 'curbside', 'dinein'].includes(handoffMode) ? { ...payload } : null,
      }
      try {
        const response = await dispatch('sendRequest', config, { root: true })

        if (response.status === 'ok') {
          commit('setCart', response.data, { root: true })
        } else {
          let messages = []
          if (typeof response.message === 'string') {
            // Force remove shopping basket error
            if (response.message === 'Could not load shopping basket') {
              commit('setLoading', false, { root: true })
              return
            }

            messages.push(response.message)
          } else if (Array.isArray(response.message)) {
            messages = [...response.message]
          } else {
            messages = response.message
          }
          commit('setErrors', messages, { root: true })
        }
        commit('setLoading', false, { root: true })
        return response // Return the response for further handling
      } catch (error) {
        console.error('Error communicating with the API:', error)
        commit('setErrors', ['Error communicating with the API'], { root: true })
        commit('setLoading', false, { root: true }) // Ensure loading is set to false on API error
        return null // Return null in case of API call failure
      }
    } else {
      commit('setLoading', false, { root: true })
      return null
    }
  },
  applyCartOrderAhead: async ({ rootState, commit, dispatch }, time) => {
    commit('setLoading', true, { root: true })

    if (!rootState.cart) {
      await dispatch('createCart', false, { root: true })
    }

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'put',
        url: `carts/${rootState.cart.id}/time`,
        data: { time },
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        response.data.type = rootState.channel && rootState.channel !== 'default' ? rootState.channel : 'mealtime'
        commit('setCart', response.data, { root: true })
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
      }
    }
    commit('setLoading', false, { root: true })
  },
  applyCartOrderAsap: async ({ rootState, commit, dispatch }) => {
    commit('setLoading', true, { root: true })

    if (!rootState.cart) {
      await dispatch('createCart', false, { root: true })
    }

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'delete',
        url: `carts/${rootState.cart.id}/time`,
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        response.data.type = rootState.channel && rootState.channel !== 'default' ? rootState.channel : 'mealtime'
        commit('setCart', response.data, { root: true })
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
      }
    }
    commit('setLoading', false, { root: true })
  },
  getNextAvailableTime: async ({ rootState, commit, dispatch }) => {
    commit('setLoading', true, { root: true })

    if (!rootState.cart) {
      await dispatch('createCart', false, { root: true })
    }

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'get',
        url: `carts/${rootState.cart.id}/time?next=true`,
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        commit('setLoading', false, { root: true })
        return response.data
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
        return null
      }
    }
    commit('setLoading', false, { root: true })
  },
  getCartAvailableTimes: async ({ rootState, dispatch, commit }, { deliveryDays, orderType }) => {
    commit('setLoading', true, { root: true })

    // Added new param `type` to improve annex flow.
    if (rootState.cart && rootState.cart.id) {
      const params = {}

      if (deliveryDays) {
        params.date = deliveryDays
      }
      if (orderType) {
        params.type = orderType
      }
      const config = {
        method: 'get',
        url: `carts/${rootState.cart.id}/time`,
        params: params,
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        commit('setLoading', false, { root: true })
        if (!response.data || response.data.length === 0) {
          if (orderType !== 'annex') {
            commit('setErrors', 'There are no available times for the date selected. Please select another date.', { root: true })
          }
        }
        return response.data
      } else {
        commit('setErrors', response.message, { root: true })
        commit('setLoading', false, { root: true })
        return []
      }
    }
    commit('setLoading', false, { root: true })
  },
  applyCartCustomField: async ({ rootState, commit, dispatch }, payload) => {
    if (!rootState.cart) {
      await dispatch('createCart', false, { root: true })
    }

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'put',
        url: `carts/${rootState.cart.id}/custom`,
        data: payload,
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        return true
      } else {
        commit('setErrors', response.message, { root: true })
        return false
      }
    }

    return false
  },
  applyCartReferral: async ({ rootState, commit, dispatch }, payload) => {
    if (!rootState.cart) {
      await dispatch('createCart', false, { root: true })
    }

    if (rootState.cart && rootState.cart.id) {
      // payload = { source: '', token: '' }
      const config = {
        method: 'put',
        url: `carts/${rootState.cart.id}/referral`,
        data: payload,
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        return true
      } else {
        commit('setErrors', response.message, { root: true })
        return false
      }
    }

    return false
  },
}
